export default __webpack_public_path__ + "static/media/arrow-white.f560e894.svg";